import Vue from "vue";
import "./root.css";
import VueRouter from "vue-router";
import routes from "./routes";
import App from "./page/App";

Vue.config.productionTip = false;
Vue.use(VueRouter);

const vueRouter = new VueRouter({
  routes: routes,
  mode: "history"
});

vueRouter.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Kalau requiresAuth, cek ada token atau engga di localStorage
    if (localStorage.getItem("accessToken") === null) {
      // Kalau ga ada token di localStorage, langsung lanjut ke Login
      next({
        path: "/gogogo"
      });
    } else {
      // Kalau ada token, lanjut ke Halaman Belakang
      next();
    }
  } else {
    // Kalau requiresAuth === false, lanjut gan.
    next();
  }
});

export const EventBus = new Vue();
Vue.component("EventBus", EventBus);

Vue.mixin({
  created() {
    this.setLang();
    EventBus.$on("setLang", () => {
      this.setLang();
    });
  },
  methods: {
    setLang() {
      this.langChosen = localStorage.getItem("langChosen");
      if (this.langChosen === null) {
        this.langChosen = "gr";
      }
    }
  },
  data() {
    return {
      langChosen: ""
    };
  }
});

new Vue({
  el: "#app",
  render: h => h(App),
  router: vueRouter
});
